// import 'whatwg-fetch'

// required
import APP from './app/appObj'
// Document Ready
// ---------------------------------------------
document.addEventListener("DOMContentLoaded", (event) => {
  APP.helpers.initComponents( document.body, APP )
})
